/**
 * Wizard step
 */
var WizardStep = /** @class */ (function () {
    function WizardStep() {
    }
    return WizardStep;
}());
export { WizardStep };
//# sourceMappingURL=wizard-step.js.map